import api from "../utils/api";

const API_URL = process.env.REACT_APP_API_URL + "/extra_charges.php";

// Get all extra charges by project ID
export const getExtraChargesByProjectId = async (projectId) => {
  const response = await api.post(API_URL, {
    action: "getByProject",
    projectId: projectId,
  });
  return response.data.extraCharges || [];
};

// Add a new extra charge
export const addExtraCharge = async (data) => {
  const response = await api.post(API_URL, {
    ...data,
    action: "add",
  });
  return response.data;
};

// Update an extra charge
export const updateExtraCharge = async (data) => {
  const response = await api.post(API_URL, {
    ...data,
    action: "update",
  });
  return response.data;
};

// Delete an extra charge (optional)
export const deleteExtraCharge = async (id) => {
  const response = await api.post(API_URL, {
    id,
    action: "delete",
  });
  return response.data;
};
